import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { onChangeParkingsAlertsFilter } from '../../../ac/onChangeMapFilters';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { parkingsAlerts } from '../../../constants/variables';
import { getStyleFilterItems } from '../../../constants/filterStylesResolver';
import { PARKING_ALERTS_FILTER } from '../../../constants/filterStyles';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const ParkingsAlertsFiltersComponent = ({
    mapFilters,
    onChangeParkingsAlertsFilter,
}) => {
    // ✅ НОВАЯ АРХИТЕКТУРА: использование стилей из filterStyles
    let items = parkingsAlerts;
    if (PARKING_ALERTS_FILTER.style && PARKING_ALERTS_FILTER.styleKey) {
        items = getStyleFilterItems(PARKING_ALERTS_FILTER.style, PARKING_ALERTS_FILTER.styleKey);
    }

    return (
        <div>
            <div className={styles.legHead}>{t`Статус сообщения о завершении парковки:`}:</div>
            <div className={styles.checkboxIconGrid}>
                {
                    items.map(({ value, color, label }) => (
                        <Fragment key={value}>
                            <CircleLegend
                                fill={color}
                                width='2vw'
                                height='2vw'
                                opacity='0.8'
                            />
                            <label htmlFor={label && label.id ? label.id : value}>
                                {typeof label === 'string' ? label : (label && i18n._(label))}
                            </label>
                            <div>
                                <label className={styles.switch}>
                                    <input
                                        type='checkbox'
                                        name='parkings'
                                        id={value}
                                        checked={mapFilters.parkingsAlerts.includes(value)}
                                        value={value}
                                        onChange={onChangeParkingsAlertsFilter}
                                    />
                                    <span className={classnames(styles.sliderRound, styles.slider)} />
                                </label>
                            </div>
                        </Fragment>
                    ))
                }
            </div>
            <br/>
            {/* <div className={styles.dataDescription}>{t`Агрегированные данные из таблицы`} public.parking_attempt_statistics</div> */}
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeParkingsAlertsFilter })(ParkingsAlertsFiltersComponent);

export const ParkingsAlertsFilter = withDisplayedLayersCheck(ConnectedComponent, t`Агрегированные алерты по парковкам`);
